<div class="progress-loader" *ngIf="isLoading">
	<div class="progress-bar"></div>
</div>
<!-- Top Options Row: All Stores & Sales Forecasts -->
<ng-container *ngIf="!isLoading; else skeletonLoader">
	<div class="print-root">
		<div class="dashboard-options-row">
			<div class="dashboard-option all-stores-box">
				<div class="all-stores-last-updated" (click)="!selectedShopName && openStoreSelectionDialog()"
					style="cursor:pointer;">{{lastUpdatedMsg}} </div>
				<div class="all-stores-title" (click)="!selectedShopName && openStoreSelectionDialog()"
					style="cursor:pointer;" *ngIf="userData.user_type != 'SHOP'">
					<span>
						@if(this.selectedStoresNames != null && selectedStoreIds) {
						@if(selectedStoreIds.length > 1) {
						{{
						lastTabIndex === 0 ? 'ALL STORES' :
						lastTabIndex === 1 ? 'SUSHI STORES' :
						lastTabIndex === 2 ? 'BENTO STORES' :
						''
						}} (
						{{selectedStoreIds.length}} /
						{{
						lastTabIndex === 0 ? allStores?.length :
						lastTabIndex === 1 ? sushiStores?.length :
						lastTabIndex === 2 ? bentoStores?.length :
						0
						}}
						)
						} @else {
						{{this.selectedStoresNames}}
						}
						} @else {
						{{selectedShopName || 'ALL STORES' }}
						}
					</span>
				</div>

				<!-- Desktop Navigation -->
				<div class="all-stores-nav desktop-nav">
					<mat-icon *ngIf="selectedShopId" (click)="onBackToHQDashboard()">arrow_back</mat-icon>
					<mat-icon (click)="printDashboard()">print</mat-icon>
					<mat-icon (click)="onRefresh()">refresh</mat-icon>
				</div>

				<!-- Mobile Navigation Menu -->
				<div class="mobile-nav-trigger">
					<button mat-icon-button [matMenuTriggerFor]="menu">
						<mat-icon>more_vert</mat-icon>
					</button>
					<mat-menu #menu="matMenu">
						<button mat-menu-item *ngIf="selectedShopId" (click)="onBackToHQDashboard()">
							<mat-icon>arrow_back</mat-icon>
							<span>Back</span>
						</button>
						<button mat-menu-item (click)="printDashboard()">
							<mat-icon>print</mat-icon>
							<span>Print</span>
						</button>
						<button mat-menu-item (click)="onRefresh()">
							<mat-icon>refresh</mat-icon>
							<span>Refresh</span>
						</button>
					</mat-menu>
				</div>
			</div>
		</div>
		<div class="dashboard-options-row">
			<div class="dashboard-options-grid">
				<div class="dashboard-option forecast-box">
					<div class="forecast-title">SALES FORECAST</div>
					<div class="forecast-value">
						{{ salesForcastWeekly | currency:'USD':'symbol':'1.0-0'}}
					</div>
					<div class="forecast-label">WEEKLY</div>
				</div>
				<div class="dashboard-option forecast-box">
					<div class="forecast-title">SALES FORECAST</div>
					<div class="forecast-value">
						{{ salesForcastAnnual | currency:'USD':'symbol':'1.0-0' }}
					</div>
					<div class="forecast-label">ANNUAL</div>
				</div>
			</div>
		</div>

		<!-- Main Summary Cards -->
		<div class="dashboard-summary-grid">
			<!-- Pass dashboardData to TodayComponent -->
			<app-today [dashboardData]="dashboardData"></app-today>
			<app-week-to-date [dashboardData]="dashboardData"></app-week-to-date>
			<app-ytd-weekly-average [dashboardData]="dashboardData"></app-ytd-weekly-average>
			<app-year-to-date [dashboardData]="dashboardData"></app-year-to-date>
			<app-top-20-today [dashboardData]="dashboardData"></app-top-20-today>
			<app-top-20-this-week [dashboardData]="dashboardData"></app-top-20-this-week>
		</div>

		<!-- Regional Sales and Results by Store -->
		<div class="dashboard-bottom-grid" *ngIf="!selectedShopId && userData?.user_type !== 'SHOP'">
			<app-regional-sales [dashboardData]="dashboardData"></app-regional-sales>
			<app-results-by-store [dashboardData]="dashboardData"
				(shopSelected)="onShopSelected($event)"></app-results-by-store>
		</div>
	</div>
</ng-container>

<ng-template #skeletonLoader>
	<!-- Skeleton: Top Options -->
	<div class="dashboard-options-row">
		<div class="dashboard-option all-stores-box skeleton-loading" style="height: 20px;"></div>
	</div>
	<div class="dashboard-options-row">
		<div class="dashboard-options-grid">
			<div class="dashboard-option forecast-box skeleton-loading" style="height: 97px;"></div>
			<div class="dashboard-option forecast-box skeleton-loading" style="height: 97px;"></div>
		</div>
	</div>

	<!-- Skeleton: Summary Cards -->
	<div class="dashboard-summary-grid">
		<div class="skeleton-card" *ngFor="let i of [1,2,3,4,5,6]">
			<div class="skeleton-title" style="width: 100%; height: 40px; margin-bottom: 0;"></div>
			<div class="skeleton-metric-grid">
				<div class="skeleton-metric-box" *ngFor="let j of [1,2,3,4,5,6,7,8,9,10,11,12,13,14]"></div>
			</div>
		</div>
	</div>

	<!-- Skeleton: Bottom Grid -->
	<div class="dashboard-bottom-grid">
		<!-- Regional Sales Skeleton -->
		<div class="skeleton-card" style="min-height: 300px;">
			<div class="skeleton-title" style="width: 30%;"></div>
			<div class="skeleton-text" style="height: 200px;"></div>
		</div>
		<!-- Results by Store Skeleton -->
		<div class="skeleton-card" style="min-height: 300px;">
			<div class="skeleton-title" style="width: 30%;"></div>
			<div class="skeleton-loading" style="height: 40px; margin-bottom: 10px;"></div>
			<div class="skeleton-loading" style="height: 40px; margin-bottom: 10px;"></div>
			<div class="skeleton-loading" style="height: 40px; margin-bottom: 10px;"></div>
			<div class="skeleton-loading" style="height: 40px; margin-bottom: 10px;"></div>
			<div class="skeleton-loading" style="height: 40px;"></div>
		</div>
	</div>
</ng-template>